import {
  ConfigurationGroupOptionType,
  ConfigurationGroupType,
  SpaPackageType,
} from 'shared-types/SpaPackage';

export function isBookableOption(option: ConfigurationGroupOptionType): boolean {
  return option.supportsTimeslots !== false;
}

export function isBookableGroup(group: ConfigurationGroupType): boolean {
  return group.isBookable !== false && group.supportsTimeslots !== false;
}

export function isBookingGroup(group: ConfigurationGroupType): boolean {
  return (
    group.isRequired || (group.supportsSelections === false && group.supportsTimeslots === true)
  );
}

export function entityHasAvailability(entity: SpaPackageType): boolean {
  const groups = Array.isArray(entity?.configurationGroups) ? entity.configurationGroups : [];
  return groups
    .filter((group) => group.isExtras === false && isBookingGroup(group))
    .every(isBookableGroup);
}
